const SPACE = {
  X0: 'var(--mui-space-x0)',
  X1: 'var(--mui-space-x1)',
  X2: 'var(--mui-space-x2)',
  X3: 'var(--mui-space-x3)',
  X4: 'var(--mui-space-x4)',
} as const;

export default SPACE;
